import { render, staticRenderFns } from "./denizbankrequests.vue?vue&type=template&id=6304c8ab&"
import script from "./denizbankrequests.vue?vue&type=script&lang=js&"
export * from "./denizbankrequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports